import { FC, ReactNode } from 'react';
import { Typography, useTheme } from '@mui/material';

import { pxToRem } from '@/theme/typography';

interface WalletProfileAuthHintProps {
  message: ReactNode;
}

export const WalletProfileAuthHint: FC<WalletProfileAuthHintProps> = ({ message }) => {
  const theme = useTheme();

  return (
    <Typography
      component='span'
      sx={{
        fontSize: {
          mobile: '16px',
          tablet: pxToRem(20),
        },
        letterSpacing: {
          tablet: pxToRem(0.1),
        },
        color: theme.palette.grey[50],
        textAlign: 'center',
      }}
    >
      {message}
    </Typography>
  );
};
